"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcartrunk = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcartrunk` : '') + (description ? ` desc-brandedcartrunk` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcartrunk"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcartrunk"
  }, description), /*#__PURE__*/_react.default.createElement("rect", {
    x: "11.2",
    y: "47.02",
    width: "10",
    height: "11",
    rx: "2",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "42.4",
    y: "47.02",
    width: "10",
    height: "11",
    rx: "2",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.32 5.27 18.25 14H44.5l2.57-8.73H16.33Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.32 4.4c-.07-.57.34-1.1.93-1.16C15.39 2.92 24.92 2 31.44 2c6.58 0 16.15.89 19.53 1.23.66.06 1.11.69.98 1.34a4.33 4.33 0 0 1-4.84 3.38c-4.1-.56-10.58-1.32-15.67-1.31-4.97 0-11.41.75-15.54 1.3a4.05 4.05 0 0 1-4.58-3.53Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.98 28.36c-1.99-6.43-4.31-14.59-7.6-15.44 0 0-8.33-1.97-16.66-1.92-10.07.06-15.88 1.92-15.88 1.92-3.68.85-5.3 8.58-7.81 15.44C3.5 40.69 7.7 49.98 9.45 49.62c13.62.29 41.6.69 44.54 0 3.68-.85 5.81-8.87 1.99-21.26Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m11.34 40.8-.43-2.97a1.19 1.19 0 0 0-1.18-1.02H6.58c-.19 0-.37.04-.53.1-.08 1.4-.06 2.7.05 3.89h5.24Z",
    fill: "#FDF1F3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.33 40.8H6.1c.1 1.17.3 2.23.55 3.17h4.69V40.8Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.32 22.02a3.86 3.86 0 0 1 3.02-3.8c3.6-.79 9.76-1.95 14.66-1.95s11.06 1.16 14.66 1.95a3.86 3.86 0 0 1 3.02 3.8V46a2 2 0 0 1-2 2H16.32a2 2 0 0 1-2-2V22.02Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m28.99 28.2-.01.83.02.97c.12-.1.76-.67.93-.67h5.41v-1.2c0-.44.38-.8.84-.8h7.12c.47 0 .64.36.64.8v2.91h4.96c.45 0 .81.34.83.77v-9.78c0-1.61-1.31-3.41-2.74-3.74-1.86-.41-4.27-.97-7.17-1.39-3.24 3.72-6.32 7.6-10.42 10.9l-.41.4Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 28a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v3h6v-3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v3h4.8a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H15.3a1 1 0 0 1-1-1V32a1 1 0 0 1 1-1H20v-3Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.02 29.84a.64.64 0 0 1 .64-.54h8.99c.33 0 .6.24.64.56L41 45.6c.05.38-.25.7-.64.7H27.3c-.4 0-.7-.34-.64-.72l2.36-15.74Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.39 30.8c0-.27.22-.48.49-.48h4.18c.27 0 .5.21.5.48 0 .26-.23.47-.5.47h-4.18a.48.48 0 0 1-.49-.47Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 30.8v-.48h1.06c.27 0 .5.21.5.48 0 .26-.23.47-.5.47H35v-.47Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.64 35.7a1 1 0 0 1 1-.84h5.56a1 1 0 0 1 .99.82l1.73 9.44a1 1 0 0 1-.99 1.18h-8.76a1 1 0 0 1-1-1.15l1.47-9.45Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "26.44",
    y: "35.85",
    width: "3.67172",
    height: "0.624382",
    rx: "0.312191",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.4 36.8c-.58 0-1.09.43-1.17 1.01l-.43 2.98h5.15c.06-1.21.02-2.53-.11-3.96-.1-.02-.19-.03-.29-.03H54.4Z",
    fill: "#FDF1F3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.8 40.79v3.17h4.74c.21-.94.35-2 .4-3.17h-5.13Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedcartrunk;